/**
 * Navigasjonskomponent
 */

import React from 'react';
import { LayoutDashboard, Trophy, User } from 'lucide-react';
import { TABS } from '../constants/config';

export const Navigation = ({ activeTab, onTabChange }) => {
  const navItems = [
    { id: TABS.STATUS, icon: LayoutDashboard, label: 'Status' },
    { id: TABS.COMPETITIONS, icon: Trophy, label: 'Løp' },
    { id: TABS.PROFILE, icon: User, label: 'Profil' }
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white/90 backdrop-blur-md border-t border-slate-100 px-10 py-5 z-30 flex justify-between items-center shadow-[0_-10px_25px_-5px_rgba(0,0,0,0.05)]">
      {navItems.map(({ id, icon: Icon, label }) => (
        <button
          key={id}
          onClick={() => onTabChange(id)}
          className={`flex flex-col items-center gap-1.5 transition-all ${
            activeTab === id 
              ? 'text-orange-600 scale-110 font-black' 
              : 'text-slate-300 hover:text-slate-400'
          }`}
        >
          <Icon className="w-6 h-6" />
          <span className="text-[8px] font-black uppercase tracking-widest">
            {label}
          </span>
        </button>
      ))}
    </nav>
  );
};
